module.exports = __webpack_public_path__ + "static/img/iso27001.1c1178e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/iso27001.png
// module id = bMyN
// module chunks = 1